import { render, staticRenderFns } from "./AppWarnings.vue?vue&type=template&id=7e38687e&"
import script from "./AppWarnings.vue?vue&type=script&lang=ts&"
export * from "./AppWarnings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports